<template>
  <div class="page">
    <section class="main-wrap">
      <div class="main-cont clear">
        <div class="main-header">
          <div class="main-h-l">
            <a href="javascript:void(0);"><img src="../../assets/images/wz_logo_c.png" /></a><span>欢迎登录吾征AI获得更多智能信息</span>
          </div>
          <a href="javascript:void(0);" @click="returnIndex" class="main-h-r">回首页看看</a>
        </div>
        <div class="main-form clear">
          <div class="main-f-tit12_10">
            <span :class="kaiguan?'av active':'av'" @click="kaiguan=true">帐号登录</span>
            <span :class="!kaiguan?'av active':'av'" @click="kaiguan=false">手机号登录</span>
          </div>
          <form>
            <!-- 帐号密码登录 -->
            <div class="main-loginUP" v-show="kaiguan">
              <!-- <span  style="width: 100%;float: left;text-align: center;font-size: 24px;">帐号登录</span> -->
              <div class="main-f-input">
                <label><input type="text" v-model="username" placeholder="请输入您的账号或手机号码" /></label>
              </div>
              <div class="main-f-input">
                <label><input type="password" v-model="password" placeholder="请输入密码" /></label>
              </div>
              <div class="main-f-input login-coder" style="margin-bottom:0;">
                <div class="login-coder-inpt">
                  <label><input type="text" v-model="code" placeholder="验证码" /></label>
                </div>
                <div class="login-coder-txt" id="getCode" @click="loginClick(1)">
                </div>
              </div>
              <div class="main-f-input but">
              <label><input type="button" value="登录" @click="loginClick(2)" /></label>
            </div>
            </div>
            <!-- 短信验证码登录 -->
            <div class="main-loginSMS" v-show="!kaiguan">
              <div class="main-f-input">
                <label><input type="text" v-model="username1" placeholder="手机号码" /></label>
              </div>
              <div class="main-f-input smsInput">
                <label><input type="number" v-model="code1" placeholder="短信验证码" />
                  <div class="send-sms" @click="sendcode"><span>{{btntxt}}</span></div>
                </label>
              </div>
              <div class="main-f-input but">
              <label><input type="button" value="登录" @click="phonesub()" /></label>
            </div>
            </div>

          </form>
          <div class="main-pass">
            <a href="javascript:void(0);" class="main-pass-l" @click="forgetPassword">忘记密码</a>
            <em>没有帐号，点击<a href="javascript:void(0);" @click="register">创建帐号</a></em>
          </div>
        </div>
        <div class="copy">
          Copyright © 2017-2021 中润普达 －
          <a href="javascript:void(0);" target="_blank">京ICP备2021002262号-1</a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import '@/assets/css/login.css'
import { request } from '@/network/request'
import { Message } from 'element-ui'
import Cookies from "js-cookie";

export default {
  data() {
    return {
      time: 60,
      btntxt: "发送验证码",
      kaiguan: true,
      username: null,
      password: null,
      code: null,
      username1: null,
      code1: null,
      uuid: null,
    }
  },
  created() {
    Cookies.remove("Admin-Token");
    this.getCaptchaImage();
  },
  methods: {
    // 手机验证码登录
    phonesub() {
      let _this = this;

      if (_this.username1 == null || _this.username1 == '') {
        Message('请输入手机号');
        return;
      }
      if (_this.code1 == null || _this.code1 == '') {
        Message('请输入验证码');
        return;
      }

      request({
        url: '/phoneLogin',
        method: 'post',
        params: {
          "phone": _this.username1,
          "code": _this.code1
        },
      }).then(res => {
        if (res.data.code == 200) {
          Cookies.set("Admin-Token", res.data.token);
          _this.$store.commit('SET_TOKEN', res.data.token);
          //成功跳转到
          _this.$router.go(-1);
          /* window.location.href = "http://bgm.wuzhengai.com/index?token=" + res.data.token;*/
        } else {
          _this.time = 0;
          _this.btntxt = "发送验证码";
          _this.disabled = false;
          Message(res.data.msg);
        }
      })

    },
    // 获取手机验证码
    getCaptchacode() {
      let _this = this;
      request({
        url: '/sendSms',
        method: 'post',
        params: {
          'phone': _this.username1
        }
      }).then(res => {
        if (res.data.code == 200) {

        } else {
          Message(res.data.msg);
        }
      })
    },
    sendcode() {
      if (this.username1 == null || this.username1 == '') {
        Message('请输入手机号');
        return;
      }
      if (this.btntxt == '发送验证码') {
        this.time = 60;
        this.timer();
        this.getCaptchacode();
      }

    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "发送验证码";
        this.disabled = false;
      }
    },
    // 返回首页
    returnIndex() {
      this.$router.push('/');
    },
    // 忘记密码
    forgetPassword() {
      this.$router.push('/forget');
    },
    // 创建帐号
    register() {
      this.$router.push('/register');
    },
    // 获取验证码
    getCaptchaImage() {
      let _this = this;
      request({
        url: '/captchaImage',
        method: 'get'
      }).then(res => {
        if (res.data.code == 200) {
          $("#getCode").empty();
          var codeUrl = 'data:image/gif;base64,' + res.data.img;
          $("#getCode").append('<img src="' + codeUrl + '">');
          _this.uuid = res.data.uuid;
        } else {
        }
      })
    },
    // 登录
    loginClick(index) {
      let _this = this;
      if (index == 1) {
        _this.getCaptchaImage();
      } else {
        if (_this.username == null || _this.username == '') {
          Message('请输入账号');
          return;
        }
        if (_this.password == null || _this.password == '') {
          Message('请输入密码');
          return;
        }
        if (_this.code == null || _this.code == '') {
          Message('请输入验证码');
          return;
        }
        request({
          url: '/login',
          method: 'post',
          params: {
            "username": _this.username,
            "password": _this.password,
            "code": _this.code,
            "uuid": _this.uuid
          },
        }).then(res => {
          if (res.data.code == 200) {
            Cookies.set("Admin-Token", res.data.token);
            _this.$store.commit('SET_TOKEN', res.data.token);
            
            
            //成功跳转到
             _this.$router.push('/personCenter/healthRecords');
             
             // 3.0tokenst 

              request({
                url: 'https://tj.wuzhengai.com/getToken',
                method: 'get',
                params: {
                  "username": _this.username,
                  "password": _this.password,
                },
              }).then(res => {
                if (res.data.code == 200) {
                 localStorage.setItem('userxinxi',res.data.token);
                  
                } else {
                }
              })
              //3.0 token end   
            /* window.location.href = "http://bgm.wuzhengai.com/index?token=" + res.data.token;*/
          } else {
            _this.loginClick(1);
            Message(res.data.msg);
          }
        })
      }
    }
  }
}

</script>
<style scoped>
.main-form form {
  width: 100%;
}

.main-f-tit12_10 {
  float: left;
  width: 330px;
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  padding: 0 20px;
  margin-top: 20px;
  cursor: pointer;
}

.main-f-tit12_10 .av {
  color: #666;
  float: left;
  margin: 0 30px;
  position: relative;
}

.main-f-tit12_10 a:hover {
  color: #14c86c;
}

.main-f-tit12_10 .active {
  color: #000;
  font-weight: 700;
}

.main-f-tit12_10 .active:hover {
  color: #000;
}

.main-f-tit12_10 .active:after {
  position: absolute;
  bottom: -10px;
  left: 50%;
  margin-left: -15px;
  content: "";
  width: 30px;
  height: 4px;
  background: #14c86c;
}

.main-loginSMS .smsInput input {
  width: 50%;
}

.main-loginSMS .send-sms {
  float: left;
  width: 50%;
  text-align: center;
  font-size: 16px;
}

.main-loginSMS .send-sms span {
  color: #c8c8c8;
}

</style>



// WEBPACK FOOTER //
// src/views/login/login.vue